import { UpsellBannerContent } from '../components/UpsellBanner';
import {
    MY01NN_Text,
    MY01ND_MY01N3_Text,
    MY01NH_MY01NP_Text,
    MY01NF_MY01NQ_Text,
    MY01NW_Text,
    MY01NX_Text,
    MY01NY_Text,
    MY01N7_Text,
    MY01MZ_MY01NA_Text,
    MY01N9_Text,
    MY01OY_Text,
    MY01N2_MY01NB_MY01NI_MY01NR_Text,
    MY01O6_MY01OA_Text,
    MY01O5_MY01O9_Text,
    MY01O7_MY01OB_Text,
    MY01O8_MY01OC_Text,
    ubDownloadEdgeLinkText,
    ubDownloadNowLinkText,
} from '../components/EdgeUpsellStrings.locstring.json';
import loc from 'owa-localize';

export const nonWin10_IE_Strings: UpsellBannerContent[] = [
    {
        contentId: 'MY01N7',
        contentMessage: loc(MY01N7_Text),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge/features?form=MY01N7&OCID=MY01N7',
    },
    {
        contentId: 'MY01NA',
        contentMessage: loc(MY01MZ_MY01NA_Text),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge/features?form=MY01NA&OCID=MY01NA',
    },
    {
        contentId: 'MY01N9',
        contentMessage: loc(MY01N9_Text),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge/features?form=MY01N9&OCID=MY01N9',
    },
    {
        contentId: 'MY01OY',
        contentMessage: loc(MY01OY_Text),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge/features?form=MY01OY&OCID=MY01OY',
    },
    {
        contentId: 'MY01NI',
        contentMessage: loc(MY01N2_MY01NB_MY01NI_MY01NR_Text),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge/features?form=MY01NI&OCID=MY01NI',
    },
    {
        contentId: 'MY01O9',
        contentMessage: loc(MY01O5_MY01O9_Text),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge/features?form=MY01O9&OCID=MY01O9',
        isBannerAggresive: true,
    },
    {
        contentId: 'MY01OA',
        contentMessage: loc(MY01O6_MY01OA_Text),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge/features?form=MY01OA&OCID=MY01OA',
        isBannerAggresive: true,
    },
    {
        contentId: 'MY01OB',
        contentMessage: loc(MY01O7_MY01OB_Text),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge/features?form=MY01OB&OCID=MY01OB',
        isBannerAggresive: true,
    },
    {
        contentId: 'MY01OC',
        contentMessage: loc(MY01O8_MY01OC_Text),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge/features?form=MY01OC&OCID=MY01OC',
        isBannerAggresive: true,
    },
];

export const nonWin10_NonIE_Strings: UpsellBannerContent[] = [
    {
        contentId: 'MY01NN',
        contentMessage: loc(MY01NN_Text),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge/features?form=MY01NN&OCID=MY01NN',
    },
    {
        contentId: 'MY01N3',
        contentMessage: loc(MY01ND_MY01N3_Text),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge/features?form=MY01N3&OCID=MY01N3',
    },
    {
        contentId: 'MY01NP',
        contentMessage: loc(MY01NH_MY01NP_Text),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge/features?form=MY01NP&OCID=MY01NP',
    },
    {
        contentId: 'MY01NQ',
        contentMessage: loc(MY01NF_MY01NQ_Text),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge/features?form=MY01NQ&OCID=MY01NQ',
    },
    {
        contentId: 'MY01NR',
        contentMessage: loc(MY01N2_MY01NB_MY01NI_MY01NR_Text),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge/features?form=MY01NR&OCID=MY01NR',
    },
];

export const macStrings: UpsellBannerContent[] = [
    {
        contentId: 'MY01NW',
        contentMessage: loc(MY01NW_Text),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge?form=MY01NW&OCID=MY01NW',
    },
    {
        contentId: 'MY01NX',
        contentMessage: loc(MY01NX_Text),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge?form=MY01NX&OCID=MY01NX',
    },
    {
        contentId: 'MY01NY',
        contentMessage: loc(MY01NY_Text),
        contentLinkButtonText: loc(ubDownloadEdgeLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge?form=MY01NY&OCID=MY01NY',
    },
];
